import React, { useEffect, useRef, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { FcEngineering } from "react-icons/fc";
import LoadingPage from "../../../Components/layouts/loading";
import { useLocation } from "react-router-dom";
import SimpleButton from "../../../Components/layouts/simple_button";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { FaFileCsv } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa6";
import PolyhouseDesigner from "../../construction sketch/polyhouse_construction";
import PolyhouseFront from "../../construction sketch/polyhouseFront";
import PolyhouseSide from "../../construction sketch/polyhouseSide";
import PolyhouseCenter from "../../construction sketch/polyhouseCenter";
import { useNavigate } from "react-router-dom";

const MaterialTableListComFlatGrow = () => {
  const printRef = useRef();

  const [checkedItems, setCheckedItems] = useState([]);
  const location = useLocation();

  const [pageData, setPageData] = useState({
    mergedList: [],
    hydrponicType: "",
    length: 0,
    width: 0,
    project: "",
  });

  const { mergedList, hydrponicType, length, width, project } = pageData;

  const [combineListGrowandFlat, setCombineListGrowandFlat] = useState([]);

  // ✅ Load from router OR localStorage
  useEffect(() => {
    if (location.state?.mergedList) {
      setPageData(location.state);

      // sync storage
      localStorage.setItem(
        "combineGrowFlatData",
        JSON.stringify(location.state)
      );
    } else {
      // 🔁 page refresh fallback
      const saved = localStorage.getItem("combineGrowFlatData");
      if (saved) {
        setPageData(JSON.parse(saved));
      }
    }
  }, [location.state]);

  // ✅ Sync UI list
  useEffect(() => {
    setCombineListGrowandFlat(Array.isArray(mergedList) ? mergedList : []);
  }, [mergedList]);
  const [loading, setLoading] = useState(false);
  const [vendor, setVendorList] = useState([]);

  // polyhouse foundation designer states
  const [BASE_SCALE, setBASE_SCALE] = useState(24); // px per meter (constant scale)
  const [footingDiaM, setFootingDiaM] = useState(0.35); // visual marker only
  const [precision, setPrecision] = useState(2); // decimals in CSV
  const [showGrid, setShowGrid] = useState(true);
  const [showLabels, setShowLabels] = useState(true); // controls **block** labels only
  const [showOutline, setShowOutline] = useState(true);
  const [showBC, setShowBC] = useState(true);
  const [showHC, setShowHC] = useState(true);
  const [entryStartLabel, setEntryStartLabel] = useState(""); // HCn start for entry cabin
  const [hcPairs, setHCPairs] = useState([]);
  const [blockName, setBlockName] = useState([]);

  const getMaxWidth = (length, width) => {
    if (length <= 36 && width <= 52) {
      return 200;
    } else if (length >= 36 && length <= 48 && width >= 52 && width <= 60) {
      return 350;
    } else {
      return 500;
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    performRequest("GET", "/materialPlanning/getVendorList")
      .then((res) => {
        if (res.status === 200) {
          setVendorList(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  let indexCount = 0;
  let Sqmtr = +length * +width;
  let SqFt = Math.ceil(Sqmtr * 10.764);
  let UsableSqMtr = (+length - 4) * (+width - 4); // this four maybe from the hockey length and width which is 4
  let HockeyLength = 4;
  let HockeyWidth = 4;
  let AvailableLength = +length - HockeyLength;
  let AvailableWidth = +width - HockeyWidth;
  let LengthBreakdown = AvailableLength / 4;
  let WidthBreakdown = AvailableWidth / 8;
  let TotalBlocks8X4Mtr = LengthBreakdown * WidthBreakdown;
  let Lenghtinft = (AvailableLength * 3.281).toFixed(3); // 1 meter=3.28084 feet round of 3.281
  let Widthinft = (AvailableWidth * 3.281).toFixed(3);
  let UsableWidth = Math.ceil(Widthinft - 5);
  let availWidth = width - 4;
  let growbagLines = (availWidth / 8) * 6;
  // Finding totalflatbed
  let TotalFlatbed;

  //   if (+hydrponicPercentage == 25) {
  //     TotalFlatbed = (TotalBlocks8X4Mtr / 4) * 2;
  //   } else if (+hydrponicPercentage == 50) {
  //     TotalFlatbed = (TotalBlocks8X4Mtr / 2) * 2;
  //   } else if (+hydrponicPercentage == 75) {
  //     TotalFlatbed = ((TotalBlocks8X4Mtr * 3) / 2) * 2;
  //   } else if (+hydrponicPercentage == 100) {
  //     TotalFlatbed = TotalBlocks8X4Mtr * 2;
  //   }

  let AFrameBlock20ft = Math.floor(UsableWidth / 20);
  let calculatedValue = (UsableWidth / 20 - AFrameBlock20ft) * 20;
  let ExtraAFrameBlockinft = calculatedValue <= 8 ? 0 : calculatedValue;
  let TotalAFrameBlocks = AFrameBlock20ft * 3 * LengthBreakdown;
  let AFrameperline = AFrameBlock20ft * 6;
  let calculatedValueAFrameExtra = Math.ceil(
    (ExtraAFrameBlockinft - 2) / 3.5 + 1
  );
  let AFrameExtra =
    calculatedValueAFrameExtra <= 1 ? 0 : calculatedValueAFrameExtra;

  let Aframelines = Math.floor(Lenghtinft / 7);
  let TotalAframes = AFrameperline * 6 + AFrameExtra * 3 * LengthBreakdown;
  let NFTpipesinFt =
    (AFrameBlock20ft * 20 + ExtraAFrameBlockinft) * Aframelines;
  let Layer7Pipesft = NFTpipesinFt * 14;
  let TotalNumberofPipes = Layer7Pipesft / 20;
  let Foggers = TotalBlocks8X4Mtr * 2;
  let FoggerLatteralPipe = Foggers * 4 + 12;
  let TotalNewFlatbedInstallation = TotalBlocks8X4Mtr * 2;

  /// CEA - NVPH
  let OD76Pipe = Math.ceil(
    (6500 * WidthBreakdown * 2 +
      4500 * ((WidthBreakdown + 1) * (LengthBreakdown + 1))) /
      6000
  );
  let OD60Pipe = Math.ceil(
    (1000 *
      ((LengthBreakdown + 1) * (WidthBreakdown + 1) + WidthBreakdown * 2) +
      8000 * ((LengthBreakdown - 1) * WidthBreakdown) +
      4000 * WidthBreakdown * 4 +
      2000 * ((LengthBreakdown - 1) * WidthBreakdown)) /
      6000
  );
  let OD48Pipe = Math.ceil(
    (5500 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2)) / 6000
  );
  let OD42Pipe = Math.ceil(
    (4000 * (LengthBreakdown * WidthBreakdown) +
      4000 * (LengthBreakdown * 2) +
      4000 * ((LengthBreakdown - 1) * 2 * (WidthBreakdown - 1)) +
      6000 * (WidthBreakdown * 2 - 2) +
      5500 * ((LengthBreakdown + 1) * WidthBreakdown) +
      4300 * ((LengthBreakdown + 1) * WidthBreakdown) +
      1200 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2) +
      4000 * (LengthBreakdown * 2 + WidthBreakdown * 4)) /
      6000
  );
  let OD33Pipe = Math.ceil(
    (4000 * (WidthBreakdown * 2 + LengthBreakdown * 2) +
      5000 * (WidthBreakdown * 4) +
      1500 * ((LengthBreakdown + 1) * 2 * WidthBreakdown) +
      1840 * ((LengthBreakdown + 1) * 2 * WidthBreakdown)) /
      6000
  );

  let OD27Pipe = Math.ceil(
    (1000 * ((LengthBreakdown + 1) * WidthBreakdown) +
      6000 * (((AvailableWidth + 1) * 2 + (AvailableLength + 1) * 2) / 6)) /
      6000
  );

  //  marking checklist checkent state initially
  useEffect(() => {
    const allItems = [...combineListGrowandFlat];
    setCheckedItems(allItems);
  }, [combineListGrowandFlat]);

  useEffect(() => {
    const listToCheck =
      hydrponicType === "hydroponicsOnly" ? combineListGrowandFlat : [];
    setCheckedItems(listToCheck);
  }, [hydrponicType]);

  //  Growbag  rendering

  // calculate combination of flatbed and growbags

  // handling checkbox

  const handleCheckboxChange = (item) => {
    setCheckedItems((prevCheckedItems) => {
      if (prevCheckedItems.includes(item)) {
        return prevCheckedItems.filter((checkedItem) => checkedItem !== item);
      } else {
        return [...prevCheckedItems, item];
      }
    });
  };

  const toTitleCase = (str = "") =>
    str
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  // checking hydroponic types

  const handleDownload = async (hydrponicType) => {
    const listToFilter =
      hydrponicType === "hydroponicsOnly" ? combineListGrowandFlat : [];

    const selectedItems = listToFilter.filter((item) =>
      checkedItems.includes(item)
    );

    // ✅ Create image URL from SVG (only when needed)
    let canvasImageURL = null;
    let totaHeight = 750;
    if (hydrponicType !== "foggers") {
      const svg = document.getElementById("svgImage");
      if (!svg) {
        alert("Graph is not loaded yet!");
        return;
      }

      const serializer = new XMLSerializer();
      const source = serializer.serializeToString(svg);

      const svgBlob = new Blob([source], {
        type: "image/svg+xml;charset=utf-8",
      });
      canvasImageURL = URL.createObjectURL(svgBlob);
    }

    const img = document.getElementById("svgImageEnd");
    const img2 = document.getElementById("svgImageCenter");
    const img3 = document.getElementById("svgImageSide");
    if (img?.height) {
      totaHeight = totaHeight - img?.height;
    }
    const newWindow = window.open("", "_blank");

    // ✅ Split into two halves
    const itemsToPrint = selectedItems.filter((item) => item?.count);
    const half = Math.ceil(itemsToPrint.length / 2);
    const leftItems = itemsToPrint.slice(0, half);
    const rightItems = itemsToPrint.slice(half);

    // ✅ Build combined rows (one <tr> for both left & right)
    const combinedRows = leftItems
      .map((item, index) => {
        const rightItem = rightItems[index]; // align row index

        return `
        <tr>
          <!-- ✅ Left Side -->
          <td style="text-align:center;">${index + 1}</td>
          <td style="text-align:center;">
            ${item?.image ? `<img src="${item.image}" width="40px"/>` : ""}
          </td>
        
          <td>
            <b>${item?.item || ""}</b>
                  ${
                    item?.brandName
                      ? `<br/><span>Brand Name: ${item?.brandName}</span>`
                      : ""
                  }
        
                 ${(() => {
                   if (!item?.specificationsNew?.length) return "";
                   const filtered = item.specificationsNew.filter(
                     (s) =>
                       (hydrponicType === "cea-nvph" && s?.type === "cea") ||
                       hydrponicType === s?.type ||
                       (hydrponicType === "hydroponicsOnly" &&
                         (s?.type === "flatbed" || s?.type === "growbags"))
                   );
                   const uniq = [
                     ...new Map(
                       filtered.map((s) => [s.specification, s])
                     ).values(),
                   ];
                   return uniq
                     .map((s) => `<br/><span>${s.specification}</span>`)
                     .join("");
                 })()}
        
           
       
        
            ${
              item?.weight
                ? `<br/><b>Weight: ${item.weight} ${item?.proUnit || ""}</b>`
                : ""
            }
          </td>
      <td style="text-align:center;">
${
  // SKUs with special rule
  ["MAT-CEA-FLA-FOG-GRO-00042"].includes(item?.sku) &&
  hydrponicType === "hydroponicsOnly"
    ? `
        Gro: ${item.countGrow || 0} ${item?.unit || ""}
        <hr/>
        <b>Tot: ${item.countGrow || 0} ${item?.unit || "-"}</b>
      `
    : // Normal logic for all other SKUs
    item?.countGrow > 0 && item?.countFlat > 0
    ? `
        Gro: ${item.countGrow} ${item?.unit || ""}
        <br/>
        Fla: ${item.countFlat} ${item?.unit || ""}
        <hr/>
        <b>Tot: ${item.countGrow + item.countFlat} ${item?.unit || "-"}</b>
      `
    : item?.count > 0
    ? `${item.count} ${item?.unit || ""}`
    : "-"
}
</td>

  <td style={{ textAlign: "center", height:"40px", width:"40px"}}>
    <input
      type="checkbox"

    />
  </td>

    <td style={{ textAlign: "center" }}>
    <input
      type="checkbox"
 
    />
  </td>

          
        
          <!-- ✅ Right Side -->
           <td style="border: none;"></td>

          <td style="text-align:center;">${
            rightItem ? half + index + 1 : ""
          }</td>
        
          <td style="text-align:center;">
            ${
              rightItem?.image
                ? `<img src="${rightItem.image}" width="40px"/>`
                : ""
            }
          </td>
        
          <td>
            <b>${rightItem?.item || ""}</b>
            ${
              rightItem?.brandName
                ? `<br/><span>Brand Name: ${rightItem?.brandName}</span>`
                : ""
            }
        
          
            ${(() => {
              if (!rightItem?.specificationsNew?.length) return "";
              const filtered = rightItem.specificationsNew.filter(
                (s) =>
                  (hydrponicType === "cea-nvph" && s?.type === "cea") ||
                  hydrponicType === s?.type ||
                  (hydrponicType === "hydroponicsOnly" &&
                    (s?.type === "flatbed" || s?.type === "growbags"))
              );
              const uniq = [
                ...new Map(filtered.map((s) => [s.specification, s])).values(),
              ];
              return uniq
                .map((s) => `<br/><span>${s.specification}</span>`)
                .join("");
            })()}
                
            ${
              rightItem?.weight
                ? `<br/><b>Weight: ${rightItem.weight} ${
                    rightItem?.proUnit || ""
                  }</b>`
                : ""
            }
          </td>
        
               <td style="text-align:center;">
${
  // SKUs with special rule
  ["MAT-CEA-FLA-FOG-GRO-00042"].includes(rightItem?.sku) &&
  hydrponicType === "hydroponicsOnly"
    ? `
        Gro: ${rightItem.countGrow || 0} ${rightItem?.unit || ""}
        <hr/>
        <b>Tot: ${rightItem.countGrow || 0} ${rightItem?.unit || "-"}</b>
      `
    : // Normal logic for all other SKUs
    rightItem?.countGrow > 0 && rightItem?.countFlat > 0
    ? `
        Gro: ${rightItem.countGrow} ${rightItem?.unit || ""}
        <br/>
        Fla: ${rightItem.countFlat} ${rightItem?.unit || ""}
        <hr/>
        <b>Tot: ${rightItem.countGrow + rightItem.countFlat} ${
        rightItem?.unit || "-"
      }</b>
      `
    : rightItem?.count > 0
    ? `${rightItem.count} ${rightItem?.unit || ""}`
    : "-"
}
</td>
  <td style={{ textAlign: "center" }}>
    <input
      type="checkbox"
    />
  </td>
    <td style={{ textAlign: "center" }}>
    <input
      type="checkbox"
    />
  </td>
         
        </tr>
        `;
      })
      .join("");

    // ✅ Print window content
    newWindow.document.write(`
    <html>
    <style>
        @media print {
          .print-material-table {
            page-break-inside: auto;
          }
          .print-material-table tr {
            page-break-inside: avoid !important;
            page-break-after: auto;
          }
          .print-material-table td,
          .print-material-table th {
            page-break-inside: avoid !important;
            word-wrap: break-word;
            white-space: normal;
          }
        }
      </style>
      <head>
        <title> Material List</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 14px;
            font-size: 12px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }
          th, td {
            border: 1px solid black;
            padding: 6px;
            vertical-align: top;
          }
          th {
            background-color: #f2f2f2;
          }
        </style>
      </head>
      <body>
        <h1 style="text-align: center;">${toTitleCase(project)}</h1>
        <h2 style="text-align: center;">Material List: ${
          hydrponicType.charAt(0).toUpperCase() + hydrponicType.slice(1)
        } (${length} length * ${width} width)</h2>

        <div class="graph-container" style="text-align: center; page-break-inside: avoid; margin-bottom: 20px;">
          <h3 style="text-align: left;">Polyhouse Foundation:</h3>
          ${
            canvasImageURL
              ? `<img src="${canvasImageURL}" height=${totaHeight}px style="display: block; margin: auto; width: auto; max-width: 95%; padding: 1px; border: 1px solid black;" />`
              : ""
          }
        </div>

        <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
          <h3 style="text-align: left;">Polyhouse - end view (Big column)</h3>
          ${
            img?.src
              ? `<img src="${img?.src}" style="display: block; margin: auto; width: auto; max-width: 100%; padding: 10px; max-width: 95%; border: 1px solid black;" />`
              : ""
          }
        </div>
        <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
          <h3 style="text-align: left;">Polyhouse - center view (No big column)</h3>
          ${
            img2?.src
              ? `<img src="${img2?.src}" style="display: block; margin: auto; width: auto; max-width: 100%; padding: 10px; max-width: 95%; border: 1px solid black;" />`
              : ""
          }
        </div>
        <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
          <h3 style="text-align: left;">Polyhouse - Side view</h3>
          ${
            img3?.src
              ? `<img src="${img3?.src}" style="display: block; margin: auto; width: auto; max-width: 100%; padding: 10px; max-width: 95%; border: 1px solid black;" />`
              : ""
          }
        </div>

        ${
          hydrponicType === "growbags" || hydrponicType === "hydroponicsOnly"
            ? `
              <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Growbag Assembly</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763189493/8_o8uuxe.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>
            `
            : ""
        }
           ${
             hydrponicType === "flatbed" || hydrponicType === "hydroponicsOnly"
               ? `
              <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Flatbed Assembly</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/15_i0nsto.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>
            `
               : ""
           }

             ${
               hydrponicType === "flatbed" ||
               hydrponicType === "hydroponicsOnly"
                 ? `
              <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Flatbed Assembly</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/13_mijm4n.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>
            `
                 : ""
             }
        
            ${
              hydrponicType === "foggers"
                ? `
              <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Foggers Assembly</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/9_gpc088.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>
            `
                : ""
            }

        
              <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Trellising Installation</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/11_1_wl3cgy.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>

                <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Electric Assembly</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/12_jsidnq.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>

                  <div class="graph-container" style="text-align: center; margin-bottom: 20px; page-break-inside: avoid;">
                <h3 style="text-align: left;">Weedmat Installation</h3>
                <img 
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1763202288/10_mruzu7.jpg"
                  style="display: block; margin: auto; width: auto; max-width: 95%; padding: 10px; border: 1px solid black;"
                />
              </div>
        <table class="print-material-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Image</th>
              <th style="text-align:left;">Name</th>
              <th>Qty</th>
              <th>L Check</th>
                <th>R Check</th>
                <th style="border: none;"></th> <!-- ✅ Spacer -->
              <th>Sr</th>
              <th>Image</th>
              <th style="text-align:left;">Name</th>
              <th>Qty</th>
              <th>L Check</th>
                <th>R Check</th>
              
            </tr>
          </thead>
          <tbody>
            ${combinedRows}
          </tbody>
        </table>
<div class="graph-container" 
     style="text-align: center; 
            page-break-inside: avoid; 
            margin-bottom: 10px;  
            margin-top: 30px; 
            border: 1px solid #000; 
            padding: 15px; 
            width: 100%;
            box-sizing: border-box;">

  <h3 style="text-align: left; margin: 0 0 10px 0;">Approval Signatures :</h3>

  <div style="display: flex; justify-content: space-between; margin-top: 25px; width: 100%;">


    <!-- Authority Sign (Center) -->
    <div style="width: 33%; text-align: left;">
      <div style="margin-bottom: 10px;">
      <img 
                    
    style="height: 50px; width: auto; margin-left: 10px;"
               
                /><br><br/>
        <b>Authority Signature</b> 
      </div>
      <div>
        <b>Date:</b> __________
      </div>
    </div>

    <!-- Loader Sign (Left) -->
    <div style="width: 33%; text-align: left;">
      <div style="margin-bottom: 10px;">
      <img 
                   
    style="height: 50px; width: auto; margin-left: 10px;"
               
                /><br><br/>
        <b>Loader Signature</b>
      </div>
      <div>
        <b>Date:</b> __________
      </div>
    </div>

    <!-- Receiver Sign (Right) -->
    <div style="width: 33%; text-align: left;">
      <div style="margin-bottom: 10px;">
         <img 
                   
    style="height: 50px; width: auto; margin-left: 10px;"
               
                /><br><br/>
        <b>Receiver Signature</b>
      </div>
      <div>
        <b>Date:</b> __________
      </div>
    </div>

  </div>
</div>



<div class="graph-container" 
     style="
        page-break-inside: avoid; 
        margin-bottom: 10px;  
        margin-top: 30px; 
        border: 1px solid #000; 
        padding: 20px; 
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
     ">

  <h3 style="text-align: left; margin: 0 0 10px 0; ">Vehicle Details :</h3><br></br>

  <!-- Vehicle Number -->
  <div style="margin-bottom: 15px;">
    <b>Vehicle Number:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div

  <!-- Driver Name -->
  <div style="margin-bottom: 15px;">
    <b>Driver Name:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div>


    <!-- Driver Contact No: -->
  <div style="margin-bottom: 15px;">
    <b>Driver Contact No:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div>


    <!--  Vehical Owner Name: -->
  <div style="margin-bottom: 15px;">
    <b> Vehical Owner Name:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div>

      <!--  Vehical Owner Number: -->
  <div style="margin-bottom: 15px;">
    <b> Vehical Owner Number:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div>


      <!--  Vehicle Chassis No:: -->
  <div style="margin-bottom: 15px;">
    <b> Vehicle Chassis No:</b> 
    <span style="display: inline-block; width: 75%; border-bottom: 1px solid #000;"></span>
  </div>
</div>


      </body>
      <script>
        document.addEventListener("DOMContentLoaded", function() {
          if ('${hydrponicType}' === "foggers") {
            const graphContainer = document.querySelector(".graph-container");
            if (graphContainer) {
              graphContainer.style.display = "none";
            }
          }
        });
      </script>
    </html>
  `);

    newWindow.document.close();
    newWindow.onafterprint = () => newWindow.close();
    newWindow.print();
  };

  const handleDownloadCSV = (hydrponicType) => {
    const listToFilter =
      hydrponicType === "hydroponicsOnly" ? combineListGrowandFlat : [];

    const selectedItems = listToFilter.filter(
      (item) => checkedItems.includes(item) && item?.count
    );

    let csvContent =
      "Sr,Item Name,HSN,SKU,Specifications,Quantity,price,Unit\n";

    selectedItems.forEach((item, index) => {
      const row = [
        index + 1,
        `"${item.item}"`,
        `"${item.hsn || "N/A"}"`,
        `"${item.sku || "N/A"}"`,
        `"${
          (item.specificationsNew ?? []).find(
            (spec) => spec.type === hydrponicType
          )?.specification || "N/A"
        }"`,
        `"${
          ["MAT-CEA-FLA-FOG-GRO-00042", "MAT-GRB-00081"].includes(item?.sku) &&
          hydrponicType === "hydroponicsOnly"
            ? item?.countGrow
            : item?.count
        }"`,
        item.cost,
        `"${item.unit || ""}"`,
      ];

      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    // link.download = `${clinetProject}_Material_List_${hydrponicType}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //   if (loading) {
  //     return <LoadingPage />;
  //   }

  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);

    // if weight is a valid number > 0 and unit is among the specified ones, calculate with weight
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }

    // fallback if weight is missing or 0
    return costperUnit * inStock;
  };

  const createMaterialList = () => {
    if (combineListGrowandFlat) {
      let data = {
        length: length,
        width: width,
        hydroponicType: "hydroponicsOnly",
        materialList: combineListGrowandFlat,
        project: project,
        listType: "combinedList",
      };

      setLoading(true);
      performRequest("POST", "/materialPlanning/create-hm-list", data)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Material List created successfully!");
            navigate(`/get-material-lists`);
          } else {
            Toast("error", "Error while uploading");
          }
        })
        .catch((err) => {
          // Toast("error", "Server Error");
          // console.error("Error", err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center d-flex">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" />
                    Create Material Planning {`(${length} * ${width})`}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 m-auto">
                  <div className="row">
                    <div className="col-lg-3 col-md-12 d-flex flex-column gap-3">
                      <div className="card table-responsive">
                        <div className="card-header text-center fs-3 fw-bold">
                          Specifications
                        </div>
                        <table className="table table-vcenter border">
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>Item Name</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{++indexCount}</td> <td>SqMtr</td>
                              <td>{Sqmtr}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>SqFt</td>
                              <td>{SqFt}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Usable SqMtr</td>
                              <td>{UsableSqMtr}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Length (div / 4)</td>
                              <td>{length}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Width (div / 8)</td>
                              <td>{width}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Hockey</td>
                              <td>{4}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Avl Length / 4</td>
                              <td>{AvailableLength}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Avl Width / 8</td>
                              <td>{AvailableWidth}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Length Breakdown</td>
                              <td>{LengthBreakdown}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Width Breakdown</td>
                              <td>{WidthBreakdown}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td>
                              <td>Total Blocks (8X4Mtr)</td>
                              <td>{TotalBlocks8X4Mtr}</td>
                            </tr>
                            {(hydrponicType == "growbags" ||
                              hydrponicType == "hydroponicsOnly") && (
                              <tr>
                                <td>{++indexCount}</td>
                                <td>Growbag Lines</td>
                                <td>{growbagLines}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {(hydrponicType === "flatbed" ||
                        hydrponicType === "growbags" ||
                        hydrponicType === "cea-nvph" ||
                        hydrponicType === "hydroponicsOnly") && (
                        <div className="card">
                          <div className="card-header text-center fs-3 fw-bold">
                            Layout {`(${length} * ${width})`}
                          </div>
                          <div className="card-body">
                            <PolyhouseDesigner
                              length={length}
                              BASE_SCALE={BASE_SCALE}
                              width={width}
                              entryStartLabel={entryStartLabel}
                              footingDiaM={footingDiaM}
                              precision={precision}
                              showGrid={showGrid}
                              showLabels={showLabels}
                              showOutline={showOutline}
                              showBC={showBC}
                              showHC={showHC}
                              blockName={blockName}
                              origin={"material-planning"}
                            />
                          </div>

                          <hr className="m-0" />
                          <PolyhouseFront
                            length={length}
                            BASE_SCALE={BASE_SCALE}
                            width={width}
                          />
                          <hr className="m-0" />
                          <PolyhouseCenter
                            length={length}
                            BASE_SCALE={BASE_SCALE}
                            width={width}
                          />
                          <hr className="m-0" />
                          <PolyhouseSide
                            length={length}
                            BASE_SCALE={BASE_SCALE}
                            width={width}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-lg-9 col-md-12">
                      <div ref={printRef} className="card table-responsive">
                        <div className="card-header text-center fs-2 fw-bold">
                          {toTitleCase(project)}: Material List-
                          <span className="text-capitalize">
                            {hydrponicType}
                          </span>{" "}
                          {`(${length} length * ${width} width)`}
                        </div>
                        <table className="table table-vcenter border">
                          <thead>
                            <tr>
                              <th style={{ minWidth: "150px" }}>
                                Sr/ HSN/ Image
                              </th>
                              <th style={{ minWidth: "170px" }}>
                                ITEM /SKU/ Weight/ formula
                              </th>
                              <th style={{ minWidth: "200px" }}>
                                Specifications
                              </th>
                              <th>In stock /count /Price</th>

                              <th>Vendors</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(hydrponicType === "hydroponicsOnly"
                              ? combineListGrowandFlat
                              : []
                            )
                              ?.filter((item) => item?.count)
                              .map(
                                (item, index) =>
                                  item?.count != "" && (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor:
                                          Number(item.count) >
                                          Number(item.inStock)
                                            ? "#ffcccc"
                                            : "transparent",
                                      }}
                                    >
                                      <td>
                                        <span
                                          style={{
                                            position: "relative",
                                            display: "inline-block",
                                          }}
                                        >
                                          <img
                                            src={item?.image}
                                            alt={item?.item}
                                            width="150"
                                            height="150"
                                            className="m-0 mt-1 mb-1"
                                            style={{ borderRadius: "8px" }}
                                          />
                                          <input
                                            type="checkbox"
                                            checked={checkedItems.includes(
                                              item
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(item)
                                            }
                                            style={{
                                              position: "absolute",
                                              top: "5px",
                                              right: "5px",
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>

                                        <br />
                                        <span className="me-1">
                                          {index + 1}.
                                        </span>
                                        <span className="fs-5">
                                          {item?.hsn && <b>HSN: {item?.hsn}</b>}
                                        </span>
                                      </td>
                                      <td>
                                        <span className="fs-5">
                                          {item?.item}
                                        </span>
                                        <br />
                                        <span className="fs-5">
                                          <b>SKU : {item?.sku}</b>
                                        </span>
                                        <br />
                                        <span className="fs-5">
                                          {item?.weight && (
                                            <>
                                              <b>
                                                Weight : {item?.weight || "N/A"}
                                                &nbsp;{item?.proUnit}
                                              </b>
                                              <br />
                                            </>
                                          )}
                                        </span>
                                        <span className="fs-5">
                                          {item?.formula && (
                                            <b>
                                              Formula : {item?.formula || "N/A"}
                                            </b>
                                          )}
                                        </span>

                                        <span className="fs-5">
                                          {item?.flatFormul && (
                                            <>
                                              <br></br>
                                              <b>
                                                Formula :{" "}
                                                {item?.flatFormul || "N/A"}
                                              </b>
                                            </>
                                          )}
                                        </span>
                                        <br></br>
                                        <span className="fs-5">
                                          {item?.mergeType && (
                                            <b>
                                              Available in :{" "}
                                              {item?.mergeType || "N/A"}
                                            </b>
                                          )}
                                        </span>
                                        <br></br>

                                        {item?.countFlat || item?.countGrow ? (
                                          <span className="fs-5">
                                            {/* <>
                                              <b>
                                                Flatbed Count :{" "}
                                                {item?.countFlat || "0"}
                                                {item?.unit || "0"}
                                              </b>
                                              <br></br>
                                              <b>
                                                Growbags Count :{" "}
                                                {item?.countGrow || "0"}
                                                {item?.unit || ""}
                                              </b>
                                              <hr className="p-0 m-0"></hr>
                                             { <b>
                                                Total Count :{" "}
                                                {item?.countFlat +
                                                  item?.countGrow}
                                                {item?.unit || ""}
                                              </b>}
                                            </> */}
                                            <>
                                              <b>
                                                Flatbed Count :{" "}
                                                {item?.countFlat || "0"}
                                                {item?.unit || ""}
                                              </b>
                                              <br />
                                              <b>
                                                Growbags Count :{" "}
                                                {item?.countGrow || "0"}
                                                {item?.unit || ""}
                                              </b>
                                              <hr className="p-0 m-0" />

                                              <b>
                                                Total Count :{" "}
                                                {[
                                                  "MAT-CEA-FLA-FOG-GRO-00042",
                                                 
                                                ].includes(item.sku)
                                                  ? item?.countGrow // ✅ ONLY growbag count
                                                  : (item?.countFlat || 0) +
                                                    (item?.countGrow || 0)}{" "}
                                                {item?.unit || ""}

                                              </b>
                                            </>
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {/* <span className="fs-5">
                                          {item?.specificationsNew &&
                                          item?.specificationsNew.length > 0
                                            ? (
                                                item?.specificationsNew ?? []
                                              ).map(
                                                (type, index) =>
                                                  type?.specification &&
                                                  ((hydrponicType ===
                                                    "cea-nvph" &&
                                                    "cea" === type?.type && (
                                                      <span className="p-0 m-0">
                                                        {type?.specification ||
                                                          "-"}
                                                      </span>
                                                    )) ||
                                                    (hydrponicType ===
                                                      type?.type && (
                                                      <span className="p-0 m-0">
                                                        {type?.specification ||
                                                          "-"}
                                                      </span>
                                                    )))
                                              )
                                            : "N/A"}
                                        </span> */}
                                        <span className="fs-5">
                                          {item?.specificationsNew &&
                                          item?.specificationsNew.length > 0
                                            ? [
                                                ...new Map(
                                                  item.specificationsNew
                                                    .filter(
                                                      (spec) =>
                                                        // ✅ CEA condition
                                                        (hydrponicType ===
                                                          "cea-nvph" &&
                                                          spec?.type ===
                                                            "cea") ||
                                                        // ✅ Same type direct match
                                                        hydrponicType ===
                                                          spec?.type ||
                                                        // ✅ HydroponicsOnly: include both flatbed & growbags
                                                        (hydrponicType ===
                                                          "hydroponicsOnly" &&
                                                          (spec?.type ===
                                                            "flatbed" ||
                                                            spec?.type ===
                                                              "growbags"))
                                                    )
                                                    // ✅ Remove duplicates by specification text
                                                    .map((spec) => [
                                                      spec?.specification,
                                                      spec,
                                                    ])
                                                ).values(),
                                              ].map((spec, i) => (
                                                <span
                                                  key={i}
                                                  className="p-0 m-0"
                                                >
                                                  {spec?.specification || "-"}
                                                </span>
                                              ))
                                            : "N/A"}
                                        </span>
                                        <br className="m-0 p-0"></br>
                                        {item?.brandName && (
                                          <p className="m-0 badge bg-green-lt">
                                            Brand Name: {item?.brandName}
                                          </p>
                                        )}
                                      </td>
                                      <td style={{ width: "120px" }}>
                                        <span className="fs-3">
                                          <b>
                                            Count :{" "}
                                            {[
                                              "MAT-CEA-FLA-FOG-GRO-00042"
                                            ].includes(item?.sku) &&
                                            hydrponicType === "hydroponicsOnly"
                                              ? item?.countGrow || 0
                                              : item?.count || 0}
                                            {item?.unit || "N/A"}
                                            <span>
                                              {item?.countKg
                                                ? ` / ${item?.countKg}kg`
                                                : ""}
                                            </span>
                                          </b>
                                        </span>
                                        <hr className="m-0"></hr>
                                        {/* {item.sku === "MAT-FOG-00062" ? (
                                          <span className="fs-5">
                                            <b>
                                              Capacity : {item?.capacity} ltr
                                            </b>
                                          </span>
                                        ) : (
                                          ""
                                        )} */}
                                        <hr className="m-0" />
                                        <span className="fs-5">
                                          <b>In Stock : {item?.inStock} </b>
                                        </span>
                                        <hr className="m-0" />
                                        <span className="fs-5">
                                          <b>
                                            Cost/ unit :{" "}
                                            {roundOffCost(item?.cost)} /{" "}
                                            {item?.proUnit}
                                          </b>
                                        </span>
                                        <hr className="m-0" />
                                        <span className="fs-5">
                                          <b>
                                            Total :{" "}
                                            {roundOffCost(
                                              getPrice(
                                                item?.count,
                                                item?.cost,
                                                item?.weight,
                                                item?.proUnit
                                              )
                                            )}
                                          </b>
                                        </span>
                                      </td>
                                      <td>
                                        {vendor
                                          .filter(
                                            (val) => val?.item === item?.item
                                          )
                                          .map((val, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                              {val.vendors.map(
                                                (name, nameIndex) => (
                                                  <>
                                                    <span
                                                      key={nameIndex}
                                                      className="p-0 m-0 me-2 fs-5"
                                                    >
                                                      <a
                                                        href={`/purchase-vendor-management/view-vendor/${name.id}`}
                                                      >
                                                        {`${nameIndex + 1}.`}
                                                        &nbsp;
                                                        {name.contactPersonName ===
                                                        "-"
                                                          ? name.businessName
                                                          : name.contactPersonName}
                                                      </a>
                                                    </span>
                                                    <br />
                                                  </>
                                                )
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </td>
                                    </tr>
                                  )
                              )}
                            <tr>
                              <td colSpan="4" className="text-end fw-bold">
                                Total Cost:
                              </td>
                              <td>
                                {roundOffCost(
                                  checkedItems.reduce(
                                    (acc, item) =>
                                      acc +
                                      (getPrice(
                                        item?.count,
                                        item?.cost,
                                        item?.weight,
                                        item?.proUnit
                                      ) || 0),
                                    0
                                  )
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="card-footer mt-3 d-print-none">
                        <div className="btn-list justify-content-end d-print-none">
                          <button
                            className="btn mx-1 mt-2 btn-primary"
                            onClick={() => createMaterialList()}
                          >
                            <FaFilePdf className="me-2 fs-2" />
                            Create Material List
                          </button>
                          {/* <button
                            className="btn mx-1 mt-2 btn-primary"
                            onClick={() => handleDownload(hydrponicType)}
                          >
                            <FaFilePdf className="me-2 fs-2" />
                            DOWNLOAD PDF
                          </button> */}
                          {/* <button
                            className="btn mx-1 mt-2 btn-primary"
                            onClick={() => handleDownloadCSV(hydrponicType)}
                          >
                            <FaFileCsv className="me-2 fs-2" />
                            DOWNLOAD CSV
                          </button> */}
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default MaterialTableListComFlatGrow;
